import { render, staticRenderFns } from "./UserDeliveryAddress.vue?vue&type=template&id=1373661a"
import script from "./UserDeliveryAddress.vue?vue&type=script&lang=js"
export * from "./UserDeliveryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports